import React from 'react'
import Slider from "react-slick";

export default function ServiceNumber() {
    const settings = {
        dots: false,
        arrows: false,
        slidesToShow: 3,
        infinite: true,
        autoplay: true,
        slidesToScroll: 1,
        pauseOnHover: false,
        cssEase: "linear",
        autoplaySpeed: 0,
        speed: 7000,
        remove: true,
        centerMode: true,
        responsive: [
            {
            breakpoint: 2560,
            settings: {
                slidesToShow: 4,
            },
            },
            {
            breakpoint: 1600,
            settings: {
                slidesToShow: 3,
            },
            },
            {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
            },
            },
            {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
            },
            },
            {
            breakpoint: 599,
            settings: {
                slidesToShow: 1,
            },
            },
        ],
    };

  return (
    <>
    <section className="servicepage-stats">
        <Slider {...settings}>
            <div className="service-stats">
                <span>200+ Projects Complete</span>
            </div>
            <div className="service-stats">
                <span>99% Timely Completion</span>
            </div>
            <div className="service-stats">
                <span>100+ Partners</span>
            </div>
            <div className="service-stats">
                <span>14K+ Planning Hours</span>
            </div>
            <div className="service-stats">
                <span>510+ Happy Clients</span>
            </div>
            <div className="service-stats">
                <span>500K+ Sq. Ft. Designed</span>
            </div>
        </Slider>
    </section>
    </>
  )
}
